import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { AppProvider, Page, TextField, FormLayout, Button, Checkbox } from "@shopify/polaris";
import translations from '@shopify/polaris/locales/es.json';

import ShopifyLogo from 'images/shopify-2025.svg';

const propTypes = {
  shopifyLoginURL: PropTypes.string.isRequired
}

const LoginForm = ({ shopifyLoginURL }) => {
  const [formState, setFormState] = useState({
    email: "",
    password: "",
    checked: false
  });

  const handleChange = (field) => {
    return (value) => setFormState({ ...formState, [field]: value });
  };
  
  const handleShopifyLogin = (e) => {
    e.preventDefault();
    document.getElementById('shopify-login-form').submit();
  };

  const csrfToken = document.querySelector("meta[name=csrf-token]").content;

  return (
    <AppProvider i18n={translations}>
      <Page>
        <FormLayout>
          <TextField
            placeholder={I18n.t("devise.actions.placeholder_email")}
            label={I18n.t("devise.actions.email")}
            value={formState.email}
            type="email"
            name="user[email]"
            onChange={handleChange("email")}
            autoComplete={formState.email}
          />
          <TextField
            placeholder={I18n.t("devise.actions.password")}
            label={I18n.t("devise.actions.password")}
            value={formState.password}
            type="password"
            name="user[password]"
            onChange={handleChange("password")}
          />
          <Checkbox
            checked={formState.checked}
            label={I18n.t("devise.actions.remember_me")}
            value={formState.checked}
            onChange={handleChange('checked')}
            name="user[remember_me]"
          />
          <Button primary submit>{I18n.t("devise.actions.log_in")}</Button>

          <div className="shopify-button-wrapper">
            <Button
              onClick={handleShopifyLogin}
              fullWidth
            >
              <div className='flex alignItemsCenter'>
                <img src={ShopifyLogo} alt="Shopify" height={32} className='mr5' />
                Ingresar con Shopify
              </div>
            </Button>
          </div>
          
          {/* Omniauth V2 requires URL to be a POST request */}
          <form 
            id="shopify-login-form" 
            action={shopifyLoginURL} 
            method="post" 
            style={{ display: 'none' }}
          >
            <input 
              type="hidden" 
              name="authenticity_token" 
              value={csrfToken} 
            />
          </form>
          
          <Button url="/users/password/new" plain>
            {I18n.t("devise.actions.forgot_password")}
          </Button>
        </FormLayout>
      </Page>
    </AppProvider>
  );
};

LoginForm.propTypes = propTypes;

export default LoginForm;